import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const INITIAL_STATE = {
  data: [],
  selectedRecordIndex: 0,
  isOverlayOpen: false,
  isFromTrendsInsights: false
};

const UserAuditRequestModel = types
  .model('UserAuditRequestModel', {
    data: types.frozen(),
    selectedRecordIndex: types.optional(types.number, 0),
    isOverlayOpen: types.optional(types.boolean, false),
    isFromTrendsInsights: types.optional(types.boolean, false)
  })
  .actions((self) => {
    // Precompute event manager to avoid repeated calls
    const eventManager = Framework.getEventManager();

    return {
      fetch(payload) {
        eventManager.publish(constants.GET_USER_AUDIT_DATA, { payload });
      },
      setResponse(response) {
        applySnapshot(self, {
          ...response,
          selectedRecordIndex: self.selectedRecordIndex,
          isOverlayOpen: self.isOverlayOpen,
          isFromTrendsInsights: self.isFromTrendsInsights
        });
        eventManager.publish(constants.GET_USER_AUDIT_DATA_RESPONSE);
      },
      setSelectedRecordIndex(index) {
        return applySnapshot(self, { ...self, selectedRecordIndex: index });
      },
      setIsOverlayOpen(value) {
        return applySnapshot(self, { ...self, isOverlayOpen: value });
      },
      setIsFromTrendsInsights(val) {
        return applySnapshot(self, { ...self, isFromTrendsInsights: val });
      },
      resetStateValues() {
        applySnapshot(self, INITIAL_STATE);
        eventManager.publish(constants.GET_USER_AUDIT_DATA_RESPONSE);
      }
    };
  })
  .views((self) => ({
    get currentSelectedRecordIndex() {
      return self.selectedRecordIndex;
    },
    get currentOverlayOpenedState() {
      return self.isOverlayOpen;
    },
    get trendsInsightsStateValue() {
      return self.isFromTrendsInsights;
    }
  }));

export default UserAuditRequestModel;
